<template>
  <Component :is="icon" />
</template>

<script lang="ts">
export default { name: 'SvgIcon' }
</script>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const props = defineProps<{
  iconName: string
}>()


const icon = defineAsyncComponent({
  loader: () => import(`../../../svg/sprite/${props.iconName}.svg`),
  onError(error, retry, fail, attempts) {
    console.error(`Error loading SVG icon`, error)
  },
})

</script>
